export const backgroundColors = {
  bg1: "#222222",
  bg2: "#0C1821",
  bg3: "black",
};
